/** @jsx jsx */
import { jsx } from 'theme-ui';
export var ListHeader = function (_a) {
    var className = _a.className, children = _a.children;
    return (jsx("div", { sx: {
            color: 'muted',
            mb: 2,
            mt: 3,
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'center',
        }, className: className }, children));
};
//# sourceMappingURL=ListHeader.js.map